/**
 * easyToMap.js
 *
 * @Author: apple
 * @Date: 2017/12/25 19:07
 */

const easyToMap = len => {
    const mapArray = [];
    for (let i = 0; i < len; i++) {
        mapArray.push(i);
    }
    return mapArray;
};

export default easyToMap;



// WEBPACK FOOTER //
// ./src/util/easyToMap.js